<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">Invoice Search</h2>
                    <InvoiceSearch v-bind:searchParams="searchParams" v-bind:invoices="invoices"
                                   v-bind:loading="loading" v-bind:resultsCount="resultsCount"></InvoiceSearch>
                </div>

                <div class="layout__width-100 layout__position-left">
                    <el-table :data="invoices" style="width: 100%;"
                              class="layout__height-600px layout__scrolling__right layout__margin__bottom-30"
                              v-loading.fullscreen.lock="loading" v-on:row-click="downloadInvoice">
                        <el-table-column prop="code" label="Code" width="150">
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="100">
                        </el-table-column>
                        <el-table-column prop="created" label="Created" width="150" :formatter="formatDateDDMMYYYYCreated">
                        </el-table-column>
                        <el-table-column prop="orderNo" label="Order No" width="150">
                        </el-table-column>
                        <el-table-column prop="branch" label="Branch" width="150">
                        </el-table-column>
                        <el-table-column prop="name" label="Name" width="300">
                        </el-table-column>
                        <el-table-column prop="noJobs" label="No Jobs" width="150">
                        </el-table-column>
                        <el-table-column prop="netTotal" label="Net Total" width="150">
                        </el-table-column>
                        <el-table-column prop="ledgerBranch" label="SL Branch" width="100">
                        </el-table-column>
                        <el-table-column prop="ledgerStatus" label="SL Status" width="100">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="layout__padding-clear layout__width-60">
                    <div class="layout__padding-20-0">
                        <el-pagination class=""
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="this.searchParams.currentPage"
                                       :page-sizes="[20, 40, 60, 80, 100]"
                                       :page-size="this.searchParams.pagination"
                                       layout="total, sizes, prev, pager, next, jumper"
                                       :total="this.resultsCount">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import InvoiceSearch from '../../components/search/InvoiceSearch.vue';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import Pagination from "../../components/Pagination";
    import {pagination} from '@/mixins/Pagination.js';

    export default {
        name: "bespokeOrdersAdmin",
        mixins: [axios, csvDownloadHelper, dataFormatter, pagination],
        components: {
            Pagination,
            InvoiceSearch,
        },
        props: {
            view: ''
        },
        data() {
            return {
                resultsCount: '',
                invoices: [],
                loading: false,
                pdfUrl: '',
                searchParams: {
                    orderSource: '',
                    orderSourceId: null,
                    orderStatus: 'ORDERED',
                    orderFreeText: '',
                    billStatus: 'ANY STATUS',
                    type: 'INVOICE',
                    top: 20,
                    pagination: 20,
                    currentPage: 1,
                    skip: 0,
                    salesDateRange: []
                },
                exportDate: new Date().toLocaleTimeString('en-GB') + '_invoices.csv',
            }
        },
        created() {
            this.isUserAuthorised();
        },
        methods: {
            csv() {
                const fields = [
                    {label: 'Id', value: 'id'},
                    {label: 'Code', value: 'code'},
                    {label: 'Type', value: 'type'},
                    {label: 'Status', value: 'status'},
                    {label: 'Created', value: 'created'},
                    {label: 'Order_No', value: 'orderNo'},
                    {label: 'Branch', value: 'branch'},
                    {label: 'Name', value: 'name'},
                    {label: 'No_Jobs', value: 'noJobs'},
                    {label: 'Net_Total', value: 'netTotal'},
                    {label: 'SL_Branch', value: 'ledgerBranch'},
                    {label: 'SL_Status', value: 'ledgerStatus'}
                ];

                this.downloadCsv(this.exportDate, fields, this.invoices)
            },
            downloadInvoice(props) {
                // console.log('here')
                const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Billing/GetInvoiceByCode?invoiceCode=` + props.code + '&access_token=' + this.returnCookie('_token')
                this.downloadLink(event, url)
            },
            resultsPerPage() {
                document.getElementById('getInvoicesPagination').click()

            },
        }
    };
</script>